import { AppTemplateVersionEntityModel } from "src/store/models/entity/appTemplateVersion/entity";
import { AppTemplateVersionHelperModel } from "src/store/models/entity/appTemplateVersion/helper";
import { AppTemplateVersionListModel } from "src/store/models/entity/appTemplateVersion/list";

export const encooAppTemplateVersionModels = {
  entity: AppTemplateVersionEntityModel,
  list: AppTemplateVersionListModel,
  helper: AppTemplateVersionHelperModel,
};
